var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 33.74 27.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 23.006)",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.74,
    height: 4.651,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 30.74,
    height: 1.651,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 11.503)",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.74,
    height: 4.651,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 30.74,
    height: 1.651,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8)",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.74,
    height: 4.651,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 30.74,
    height: 1.651,
    rx: 0.5,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.036a10ae8fe004db50737493246b1b4e.svg";
export { ForwardRef as ReactComponent };